'use strict';

function isEmpty(obj) {
   if (typeof obj === 'undefined' || obj === null || obj === '') {
       return true;
   }
   if (typeof obj === 'number' && isNaN(obj)) {
       return true;
   }
   if (obj instanceof Date && isNaN(Number(obj))) {
       return true;
   }
   return false;
}

function isInteger(value) {
    if(!isEmpty(value)) {
        value = parseInt(value);
        return !isNaN(value);
    }
    return false;
}

function isFloat(value) {
    if(!isEmpty(value)) {
        value = parseFloat(value);
        return !isNaN(value);
    }
    return false;
}

function isNumber(value) {
    return isInteger(value) || isFloat(value);
}

function isDate(value, lang) {
    if(!isEmpty(value)) {
        switch(lang) {
            case 'en' : {
               return (value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/));
            } break;
            case 'cz' : {
               return (value.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/));
            } break;
        }

        return isDate(value, 'en') || isDate(value, 'cz');
    }
    return false;
}

function isEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

function validateInputs($inputs, validators, parentSelector) {
    parentSelector = parentSelector || '.form-group';

    var isValid = true;
    $inputs.each(function () {
        var $input = $(this);
        var $parent = $input.closest(parentSelector);
        var value = $input.val();

        $parent.removeClass('has-error');
        $.each(validators, function (key, validator) {
            switch(validator) {
                case 'date' : {
                    if (!isEmpty(value) && !isDate(value)) {
                        $parent.addClass('has-error');
                    }
                } break;
                case 'email' : {
                    if (!isEmpty(value) && !isEmail(value)) {
                        $parent.addClass('has-error');
                    }
                } break;
                case 'number' : {
                    if (!isEmpty(value) && !isNumber(value)) {
                        $parent.addClass('has-error');
                    }
                } break;
                case 'float' : {
                    if (!isEmpty(value) && !isFloat(value)) {
                        $parent.addClass('has-error');
                    }
                } break;
                case 'integer' : {
                    if (!isEmpty(value) && !isInteger(value)) {
                        $parent.addClass('has-error');
                    }
                } break;
                case 'not_empty' : {
                    if (isEmpty(value)) {
                        $parent.addClass('has-error');
                    }
                } break;
                case 'positive' : {
                    if ((isFloat(value) || isInteger(value)) && value < 0) {
                        $parent.addClass('has-error');
                    }
                } break;
                case 'negative' : {
                    if ((isFloat(value) || isInteger(value)) && value >= 0) {
                        $parent.addClass('has-error');
                    }
                } break;
            }

            if($parent.hasClass('has-error')) {
                isValid = false;
            }
        });
    });

    return isValid;
}
